export type ThemePreference = "system" | "light" | "dark";
export type ResolvedTheme = "light" | "dark";

const STORAGE_KEY = "mairko-matrix-theme";

export function readThemePreference(): ThemePreference {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (raw === "light" || raw === "dark" || raw === "system") return raw;
	} catch {
		/* private mode */
	}
	return "system";
}

export function writeThemePreference(preference: ThemePreference): void {
	try {
		localStorage.setItem(STORAGE_KEY, preference);
	} catch {
		/* private mode */
	}
}

export function systemTheme(): ResolvedTheme {
	if (typeof window === "undefined") return "dark";
	return window.matchMedia("(prefers-color-scheme: light)").matches
		? "light"
		: "dark";
}

export function resolveTheme(preference: ThemePreference): ResolvedTheme {
	return preference === "system" ? systemTheme() : preference;
}

/** Cycle system → light → dark → system. */
export function nextThemePreference(
	current: ThemePreference,
): ThemePreference {
	switch (current) {
		case "system":
			return "light";
		case "light":
			return "dark";
		case "dark":
			return "system";
		default: {
			const _exhaustive: never = current;
			return _exhaustive;
		}
	}
}

export function applyResolvedTheme(theme: ResolvedTheme): void {
	document.documentElement.dataset.theme = theme;
	document.documentElement.style.colorScheme = theme;
}
